import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from './user.service';
import { AccountService } from './account.service';
import { ENVIRONMENT_CONFIG } from '@shared/injection-token/environment-config';
import { CookieService } from 'ngx-cookie-service';
import { ENVIRONMENT } from '@shared/injection-token/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  environment = inject(ENVIRONMENT);
  environmentConfig = inject(ENVIRONMENT_CONFIG);
  routesPath = this.environmentConfig.routes;

  constructor(
    private userService: UserService,
    private accountService: AccountService,
    private router: Router,
    private cookieService: CookieService
  ) {}

  signIn(item: { token: string; validitySeconds: number }) {
    this.cookieService.set('token', item.token, {
      expires: item.validitySeconds, // 7 jours
      domain: this.environment.production ? `.${this.environmentConfig.host}` : undefined,
      path: '/',
      sameSite: 'Lax',
      secure: this.environment.production,
    });
    this.accountService.getAccount().subscribe((user) => {
      this.userService.setUser(user);
      void this.router.navigateByUrl(this.routesPath.dashboard);
    });
  }

  logout(redirect = true) {
    this.cookieService.delete(
      'token',
      '/',
      this.environment.production ? `.${this.environmentConfig.host}` : undefined
    );
    this.userService.reset();
    if (redirect) {
      void this.router.navigateByUrl('/');
    }
  }

  isSignIn(): boolean {
    return !!this.cookieService.get('token');
  }

  getToken() {
    return this.cookieService.get('token');
  }
}
